<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="main-container">
    <!-- Left side content for signup or info -->
    <div class="signup-form">
      <div class="signup-content">
        <div class="icons-set">
          <i class="voyado-iconwhiteimg"></i>
          <i class="ml-2 engage-iconwhiteimg"></i>
        </div>
        <p class="signup-description">{{ lmodel.onsiteEngmnt }}</p>
        <div class="signup-list">
          <div>
            <i class="check-circle"></i>
          </div>
          <div class="ml-2 signup-list-item">
            {{ lmodel.ldGenrtn }}
          </div>
        </div>
        <div class="signup-list py-0">
          <div>
            <i class="check-circle"></i>
          </div>
          <div class="ml-2 signup-list-item">
            {{ lmodel.incrsConvrsn }}
          </div>
        </div>
        <div class="signup-list">
          <div>
            <i class="check-circle"></i>
          </div>
          <div class="ml-2 signup-list-item">
            {{ lmodel.incrsCntctbs }}
          </div>
        </div>
        <div>
          <span class="bottom-text">{{ lmodel.dnthvAccssyt }}</span>
        </div>
        <PrimeButton
          :label="linkVariable"
          class="btn-signup w-full mt-5"
          type="button"
          @click="redirectToUrl"
        ></PrimeButton>
      </div>
    </div>
    <div class="ml-3"></div>
    <!-- Right side content for login -->
    <form @submit.prevent="login" class="login-form form-container">
      <div class="check">
        <div class="loginicons-set">
          <i class="voyado-iconimg"></i>
          <i class="engage-iconimg ml-2"></i>
        </div>
        <div class="login-header-sublabel mt-3">
          {{ lmodel.cstmrExp }}
        </div>
        <div class="form-inputs mt-3">
          <div>
            <label class="form-control-label" for="username">{{
              lmodel.usrnm
            }}</label>
            <InputText
              id="username"
              type="email"
              aria-describedby="username-help"
              class="w-full mt-2"
              maxlength="50"
              v-model="vmodel.email"
              v-on:keyup.enter="login"
            />
          </div>
          <div>
            <label for="password" class="form-control-label">{{
              lmodel.psswrd
            }}</label>
            <InputText
              id="password"
              type="password"
              aria-describedby="password-help"
              class="w-full mt-2"
              maxlength="200"
              v-model="vmodel.password"
              v-on:keyup.enter="login"
            />
            <span
              v-if="
                v$.vmodel.password.$error &&
                v$.vmodel.password.required.$invalid
              "
              id="password-help"
              class="p-error mt-2"
            >
              {{
                v$.vmodel.password.required.$message.replace(
                  "Value",
                  "Password"
                )
              }}
            </span>
          </div>
          <label
            class="form-label-forgot-password cursor-pointer mb-0 mt-2"
            @click="forgotpassword"
            >{{ lmodel.frgtPswrd }}</label
          >
        </div>
        <div>
          <PrimeButton
            :label="lmodel.lgin"
            class="btn-login mt-3"
            type="submit"
          ></PrimeButton>
        </div>
        <div class="login-footer mt-4" v-if="inFrame || 1 == 1">
          <div>
            <i class="info-icon"></i>
          </div>
          <div class="login-footer-label">
            <span>{{ lmodel.lgnAgn }}</span>
            <span> {{ lmodel.sprtPrt }}</span>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import DataLayerService from "@/services/data-layer.service.js";
import { required } from "@vuelidate/validators";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      selectedLanguage: "",
      lmodel: {},
      vmodel: {
        email: "",
        password: "",
      },
      inFrame: false,
      submitted: false,
      linkVariable: "",
    };
  },
  validations() {
    return {
      vmodel: {
        email: {},
        password: { required },
      },
    };
  },
  created() {
    // Check for tenant parameter and redirect if present
    // this.checkTenantAndRedirect();
    // Proceed with fetching labels if no redirect
    this.getLabel();
  },
  mounted() {
    this.setLinkHtml();
    this.prefillEmailFromIframe();
  },
  methods: {
    // Check for tenant in URL and redirect if present
    async checkTenantAndRedirect() {
      console.log("test")
      const url = window.location.href;
      let tenant = this.getParamValue(url, "tenant");
      // let email = this.getParamValue(url, "email");
      // let language = this.getParamValue(url, "language");
      // let hide = this.getParamValue(url, "hide");
      // let organizationId = this.getParamValue(url, "organizationId");

      if (!tenant) {
        console.info(
          "No tenant parameter found in URL, proceeding to login page"
        );
        return;
      }
      this.login();
      // try {
      //   // const organizationId = ""; // Consider moving to config
      //   const redirectUri =
      //     "https://manager.test.onsite.voyado.com/deals";
      //   const apiUrl = `/auth/cognitourl?domain=test-manager.auth.eu-central-1.amazoncognito.com&orgId=${organizationId}&redirect=${
      //     redirectUri
      //   }&tenant=${tenant}`;
      //   console.log(apiUrl, tenant, email, language, hide, organizationId, "Before response");

      //   const response = await DataLayerService.get(apiUrl);
      //   console.log("API Response:", response);

      //   // Validate response
      //   if (typeof response !== "string" || !response) {
      //     throw new Error("Invalid or empty response from API");
      //   }

      //   // Prepend protocol to make it a fully qualified URL
      //   const redirectUrl = `https://${response}`;
      //   console.info("Redirecting to:", redirectUrl);

      //   // Perform redirection
      //   window.location.assign(redirectUrl); // Preferred over window.location.href for clarity
      // } catch (error) {
      //   console.error("Failed to fetch Cognito URL:", error.message);
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "Redirection Error",
      //     detail: "Unable to redirect. Please try logging in manually.",
      //     life: 5000,
      //   });
      //   // Proceed to login page as fallback
      // }
    },

    // Check if the page is inside an iframe
    inIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },

    // Get the iframe's src attribute if same-origin
    getIframeSrcIfSameOrigin() {
      try {
        const iframes = window.parent.document.getElementsByTagName("iframe");
        for (let i = 0; i < iframes.length; i++) {
          if (iframes[i].contentWindow === window) {
            return iframes[i].getAttribute("src");
          }
        }
      } catch (err) {
        console.warn(
          "Access denied to parent iframe src (possible cross-origin):",
          err
        );
      }
      return null;
    },

    // Extract parameter value from URL
    getParamValue(url, paramName) {
      if (url && paramName) {
        const dedcodedURL = decodeURIComponent(url);
        const regex = new RegExp(`[?&]${paramName}=([^&]*)`);
        const match = dedcodedURL.match(regex);
        const value = match ? match[1] : null;
        console.log(
          `getParamValue - param: ${paramName}, value: ${value}, url: ${dedcodedURL}`
        );
        return value;
      }
      return null;
    },

    // Prefill email from iframe's src or URL
    prefillEmailFromIframe() {
      const url = window.location.href;
      let sourceUrl = url;
      let email = null;

      if (this.inIframe()) {
        this.inFrame = true;
        console.log("Page is inside an iframe");

        // Try iframe src first
        const iframeSrc = this.getIframeSrcIfSameOrigin();
        if (iframeSrc) {
          console.log("Iframe src:", iframeSrc);
          sourceUrl = iframeSrc;
          email = this.getParamValue(iframeSrc, "email");
        }

        // Fallback to originalUrl if no email from iframe src
        if (!email) {
          const originalUrl = this.getParamValue(url, "originalUrl");
          if (originalUrl) {
            sourceUrl = decodeURIComponent(originalUrl);
            console.log("Using originalUrl for email:", sourceUrl);
            email = this.getParamValue(sourceUrl, "email");
          }
        }
      } else {
        this.inFrame = false;
        console.log("Page is not inside an iframe");
        email = this.getParamValue(url, "email");
      }

      // Fallback to redirect param if no email found
      if (!email) {
        const redirect = this.getParamValue(url, "redirect");
        if (redirect) {
          const decodedRedirect = decodeURIComponent(redirect);
          email = this.getParamValue(decodedRedirect, "email");
          console.log("Extracted email from redirect param:", email);
        }
      }

      if (email) {
        this.vmodel.email = email;
        console.log("Prefilled email:", email);
      } else {
        console.log("No email found in sourceUrl, originalUrl, or redirect");
      }

      // Log redirect for debugging
      const redirectParam = this.getParamValue(url, "redirect");
      console.log("Redirect param:", redirectParam);
    },

    // Set the link text for the button
    setLinkHtml() {
      if (this.lmodel.tlmemr) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = this.lmodel.tlmemr;
        const anchor = tempDiv.querySelector("a");
        this.linkVariable = anchor
          ? anchor.textContent.trim()
          : "Tell me more!";
        console.log("Extracted linkVariable:", this.linkVariable);
      } else {
        console.log("tlmemr not available yet");
        this.linkVariable = "Tell me more!";
      }
    },

    // Redirect to URL with email and tenant from iframe src
    redirectToUrl() {
      let email = null;
      let tenant = null;
      const defaultLink =
        "https://knowledge.voyado.com/on-site-messaging-users?email={{email}}&tenant_id={{tenant_id}}&utm_source=%20product&utm_medium=engage&utm_campaign=onsite_messaging_login_screen";

      // Step 1: Get source URL (iframe src or fallback)
      let sourceUrl = window.location.href;
      if (this.inIframe()) {
        const iframeSrc = this.getIframeSrcIfSameOrigin();
        if (iframeSrc) {
          console.log("Using iframe src for redirect:", iframeSrc);
          sourceUrl = iframeSrc;
        } else {
          const originalUrl = this.getParamValue(
            window.location.href,
            "originalUrl"
          );
          if (originalUrl) {
            sourceUrl = decodeURIComponent(originalUrl);
            console.log("Using originalUrl for redirect:", sourceUrl);
          }
        }
      }

      // Step 2: Extract email and tenant parameters
      email = this.getParamValue(sourceUrl, "email");
      tenant = this.getParamValue(sourceUrl, "tenant");

      // Step 3: Prepare the redirect URL
      let redirectLink = this.lmodel.tlmemr || defaultLink;
      if (email) {
        redirectLink = redirectLink.replace(
          "email={{email}}",
          `email=${email}`
        );
      } else {
        redirectLink = redirectLink.replace(/email={{email}}&?/, "");
      }
      if (tenant) {
        redirectLink = redirectLink.replace(
          "tenant_id={{tenant_id}}",
          `tenant_id=${tenant}`
        );
      } else {
        redirectLink = redirectLink.replace(/tenant_id={{tenant_id}}&?/, "");
      }

      // Step 4: Clean up any empty query parameters
      redirectLink = redirectLink.replace(/&&/g, "&").replace(/\?&/, "?");
      if (redirectLink.endsWith("&")) {
        redirectLink = redirectLink.slice(0, -1);
      }

      // Step 5: Extract the final href and redirect
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = redirectLink;
      const anchor = tempDiv.querySelector("a");
      const finalLink = anchor ? anchor.href : redirectLink;

      if (finalLink) {
        console.log("Redirecting to:", finalLink);
        window.open(finalLink, "_blank");
      } else {
        console.warn("No valid redirect URL found");
        this.$toast.add({
          severity: "warn",
          summary: "Warning",
          detail: "Unable to redirect to external link",
          life: 3000,
        });
      }
    },

    // Extract language code from locale
    extractLanguageCode(locale) {
      if (locale) {
        const normalizedLocale = locale.trim().toLowerCase();
        const languageCode = normalizedLocale.split(/[-_]/)[0];
        return languageCode;
      }
      return "en";
    },

    // Fetch labels based on language
    async getLabel() {
      const url = this.$route.fullPath;
      let language = this.getParamValue(url, "language");
      const extractedLanguage = language
        ? this.extractLanguageCode(language)
        : "en";

      try {
        localStorage.setItem("selectedLanguage", extractedLanguage);
        const languageCode = localStorage.getItem("selectedLanguage");
        const response = await DataLayerService.get(
          `/resource/${languageCode}?forceRefresh=true`
        );

        if (response && Object.keys(response).length > 0) {
          const localHeader = {
            welcome1: response.Welcome1,
            dealList1: response.DealList1,
            overview1: response.Overview1,
            contentGenerator1: response.ContentGenerator1,
            newSite1: response.NewSite1,
            menuManageDeals: response.MenuManageDeals,
            pinMenu1: response.PinMenu1,
            menuDashboard: response.MenuDashboard,
            menuConfiguration: response.MenuConfiguration,
            menuInsightReports: response.MenuInsightReports,
            menuUsers: response.MenuUsers,
            menuTranslation: response.MenuTranslation,
            menuOprationWizard: response.menuOprationWizard,
            menuDealWizard: response.MenuDealWizard,
            menuNewWizardPage: response.MenuNewWizardPage,
            menuContinueFromDraft: response.MenuContinueFromDraft,
            menuSites: response.MenuSites,
            menuCompany: response.MenuCompany,
            menuInstallation: response.MenuInstallation,
            menuPerformance: response.MenuPerformance,
            menuMyAmbassadors: response.MenuMyAmbassadors,
            menuMyFriends: response.MenuMyFriends,
            relations: response.relations,
            menuFailContact: response.MenuFailContact,
            menuErrorSummary: response.menuErrorSummary,
          };
          this.$store.commit("setHeaderSidebar", localHeader);

          const updatedLModel = {};
          Object.keys(response).forEach((key) => {
            const lowerCaseKey = key.charAt(0).toLowerCase() + key.slice(1);
            updatedLModel[lowerCaseKey] = response[key];
          });
          this.lmodel = updatedLModel;
          this.setLinkHtml();
        } else {
          console.warn("No data returned from the API.");
        }
      } catch (error) {
        console.error("Error fetching labels:", error);
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Failed to load language resources",
          life: 3000,
        });
      }
    },

    // Handle login submission
    async login() {
        const isFormCorrect = await this.v$.$validate();
        this.submitted = true;
        if (!isFormCorrect) {
          this.submitted = false;
          return;
        }

      const payload = {
        email: this.vmodel.email,
        password: this.vmodel.password,
      };
      this.$store.state.loader = true;

      try {
        const result = await DataLayerService.post(
          "/auth/Authenticate",
          payload,
          false
        );
        if (result.hasTempPw) {
          await this.$store.commit("setLoginEmail", this.vmodel.email);
          await this.$store.commit("setSession", result.session);
          await this.$router.push({ name: "ChangePassword" });
        } else if (result.isPasswordResetRequired) {
          await this.$store.commit("setForgotPasswordEmail", this.vmodel.email);
          await this.$router.push({ name: "ResetPassword" });
        } else if (!result.idToken) {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Invalid Authentication",
            life: 3000,
          });
        } else {
          await this.$store.commit("setCognitoToken", result.idToken);
          await this.$store.commit("setCognitoUsername", this.vmodel.email);
          await this.$store.commit("setCognitoEmail", this.vmodel.email);

          // Get redirect parameters
          const url = this.$route.fullPath;
          let redirectPath =
            this.getParamValue(url, "redirect") ||
            this.getParamValue(url, "path");

          // Log redirect for debugging
          console.log("Login: Redirect path:", redirectPath);

          // Validate redirectPath against known routes
          const validRoutes = this.$store.state.routes || [];
          const isValidRedirect =
            redirectPath &&
            validRoutes.some(
              (route) =>
                route.Path === redirectPath || route.Name === redirectPath
            );

          if (isValidRedirect) {
            console.log("Login: Valid redirect, navigating to:", redirectPath);
            await this.$router.push({ path: redirectPath });
          } else {
            // Role-based default redirect
            const defaultRoute =
              result.role === "Accessadmin" ? "UserList" : "VoyadoDashboard";
            console.log(
              "Login: Invalid or no redirect, using default:",
              defaultRoute
            );
            await this.$router.push({ name: defaultRoute });
            if (redirectPath) {
              this.$toast.add({
                severity: "warn",
                summary: "Warning",
                detail: "Invalid redirect path, redirected to dashboard",
                life: 3000,
              });
            }
          }
        }
      } catch (error) {
        console.error("Login error:", error);
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Authentication failed. Please try again.",
          life: 3000,
        });
      } finally {
        this.$store.state.loader = false;
        this.submitted = false;
      }
    },

    // Navigate to forgot password page
    forgotpassword() {
      this.$router.push({ name: "ForgotPassword" });
    },
  },
};
</script>

<style scoped>
@import "@/assets/css/login.css";
</style>
